module.exports = __webpack_public_path__ + "static/media/glasschain-jelliesOnly-Narrow.d401387e.png";